import { Api } from '@recargas-dominicanas/core/api';
import type { ICustomer } from '@recargas-dominicanas/core/types';

export class AuthApi extends Api {

  public static async login(username: string, password: string) {
    return this.post('/dist/auth/login', { username, password });
  }

  public static async getUser() {
    return this.get<ICustomer>('/dist/auth/user');
  }
}
